'use strict';

module.exports = require('./Trigger');


//////////////////
// WEBPACK FOOTER
// ./~/bee-overlay/build/trigger/index.js
// module id = 418
// module chunks = 0